import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-m-2 kn-overflow" }
const _hoisted_2 = {
  key: 1,
  class: "p-grid p-m-2",
  "data-test": "card-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_WorkspaceRepositoryBreadcrumb = _resolveComponent("WorkspaceRepositoryBreadcrumb")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Message = _resolveComponent("Message")
  const _component_WorkspaceCard = _resolveComponent("WorkspaceCard")
  const _component_DetailSidebar = _resolveComponent("DetailSidebar")
  const _component_WorkspaceRepositoryMoveDialog = _resolveComponent("WorkspaceRepositoryMoveDialog")
  const _component_WorkspaceWarningDialog = _resolveComponent("WorkspaceWarningDialog")
  const _component_Menu = _resolveComponent("Menu")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
      start: _withCtx(() => [
        _createVNode(_component_Button, {
          id: "showSidenavIcon",
          icon: "fas fa-bars",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('showMenu')))
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('workspace.menuLabels.myRepository')), 1)
      ]),
      end: _withCtx(() => [
        (_ctx.toggleCardDisplay)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              icon: "fas fa-list",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _ctx.toggleDisplayView
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.toggleCardDisplay)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              icon: "fas fa-th-large",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _ctx.toggleDisplayView
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_WorkspaceRepositoryBreadcrumb, {
      breadcrumbs: _ctx.breadcrumbs,
      onBreadcrumbClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('breadcrumbClicked', $event)))
    }, null, 8, ["breadcrumbs"]),
    _createVNode(_component_InputText, {
      class: "kn-material-input p-m-2",
      style: _ctx.mainDescriptor.style.filterInput,
      modelValue: _ctx.searchWord,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchWord = $event)),
      type: "text",
      placeholder: _ctx.$t('common.search'),
      onInput: _ctx.searchItems,
      "data-test": "search-input"
    }, null, 8, ["style", "modelValue", "placeholder", "onInput"]),
    _createVNode("div", _hoisted_1, [
      (!_ctx.toggleCardDisplay)
        ? (_openBlock(), _createBlock(_component_DataTable, {
            key: 0,
            class: "p-datatable-sm kn-table  p-mx-2",
            value: _ctx.filteredDocuments,
            loading: _ctx.loading,
            dataKey: "biObjId",
            responsiveLayout: "stack",
            breakpoint: "600px",
            "data-test": "documents-table"
          }, {
            empty: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
                class: "p-column-filter"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                return (_openBlock(), _createBlock(_component_Column, {
                  field: col.field,
                  header: _ctx.$t(col.header),
                  key: col.field,
                  sortable: true
                }, null, 8, ["field", "header"]))
              }), 128)),
              _createVNode(_component_Column, {
                class: "icon-cell",
                style: _ctx.mainDescriptor.style.iconColumn
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_Button, {
                    icon: "fas fa-ellipsis-v",
                    class: "p-button-link",
                    onClick: ($event: any) => (_ctx.showMenu($event, slotProps.data))
                  }, null, 8, ["onClick"]),
                  _withDirectives(_createVNode(_component_Button, {
                    icon: "fas fa-info-circle",
                    class: "p-button-link",
                    onClick: ($event: any) => (_ctx.showSidebar(slotProps.data)),
                    "data-test": 'info-button-' + slotProps.data.documentName
                  }, null, 8, ["onClick", "data-test"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('workspace.myModels.showInfo'),
                      void 0,
                      { left: true }
                    ]
                  ]),
                  _createVNode(_component_Button, {
                    icon: "fas fa-play-circle",
                    class: "p-button-link",
                    onClick: ($event: any) => (_ctx.executeDocumentFromOrganizer(slotProps.data))
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          }, 8, ["value", "loading"]))
        : _createCommentVNode("", true),
      (_ctx.toggleCardDisplay)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            (_ctx.filteredDocuments.length === 0)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 0,
                  class: "kn-flex p-m-2",
                  severity: "info",
                  closable: false,
                  style: _ctx.mainDescriptor.style.message
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
                  ]),
                  _: 1
                }, 8, ["style"]))
              : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.filteredDocuments, (document, index) => {
                  return (_openBlock(), _createBlock(_component_WorkspaceCard, {
                    key: index,
                    viewType: 'repository',
                    document: document,
                    onExecuteDocumentFromOrganizer: _ctx.executeDocumentFromOrganizer,
                    onMoveDocumentToFolder: _ctx.moveDocumentToFolder,
                    onDeleteDocumentFromOrganizer: _ctx.deleteDocumentConfirm,
                    onOpenSidebar: _ctx.showSidebar
                  }, null, 8, ["document", "onExecuteDocumentFromOrganizer", "onMoveDocumentToFolder", "onDeleteDocumentFromOrganizer", "onOpenSidebar"]))
                }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_DetailSidebar, {
      visible: _ctx.showDetailSidebar,
      viewType: 'repository',
      document: _ctx.selectedDocument,
      onExecuteDocumentFromOrganizer: _ctx.executeDocumentFromOrganizer,
      onMoveDocumentToFolder: _ctx.moveDocumentToFolder,
      onDeleteDocumentFromOrganizer: _ctx.deleteDocumentConfirm,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDetailSidebar = false)),
      "data-test": "detail-sidebar"
    }, null, 8, ["visible", "document", "onExecuteDocumentFromOrganizer", "onMoveDocumentToFolder", "onDeleteDocumentFromOrganizer"]),
    _createVNode(_component_WorkspaceRepositoryMoveDialog, {
      visible: _ctx.moveDialogVisible,
      propFolders: _ctx.folders,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.moveDialogVisible = false)),
      onMove: _ctx.handleDocumentMove
    }, null, 8, ["visible", "propFolders", "onMove"]),
    _createVNode(_component_WorkspaceWarningDialog, {
      visible: _ctx.warningDialogVisbile,
      warningMessage: _ctx.warningMessage,
      onClose: _ctx.closeWarningDialog
    }, null, 8, ["visible", "warningMessage", "onClose"]),
    _createVNode(_component_Menu, {
      id: "optionsMenu",
      ref: "optionsMenu",
      model: _ctx.menuButtons
    }, null, 8, ["model"])
  ], 64))
}